module.exports = __webpack_public_path__ + "img/bring-forward.e24da949.svg";